function addProductFromCollection(id) {
  const button = event.currentTarget;
  const spinner = button.querySelector(".quick-add-spinner");
  const spanEle = button.querySelector("span");
  const cartURL = "/cart";

  if (button.classList.contains("loading")) return;

  button.classList.add("loading");
  spinner.classList.remove("hidden");
  spanEle.style.visibility = "hidden";

  let formData = {
    items: [
      {
        id: id,
        quantity: 1,
      },
    ],
  };
  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then(async (response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then(async (final) => {
      // Success: Hide spinner, show text, remove loading class
      spinner.classList.add("hidden");
      spanEle.style.visibility = "visible";
      button.classList.remove("loading");
      console.log("Item Added to Cart!!");
      Swal.fire({
        title: "Success!",
        text: "Item added to your cart",
        icon: "success",
        showConfirmButton: true, 
        confirmButtonText: "View Cart",
        showDenyButton: true,
        denyButtonText: "Continue Shopping",
        showCancelButton: false,
        customClass: {
          confirmButton: 'button',
          denyButton: 'button',
          actions: 'atc-popup-actions'
        },
        buttonsStyling: false
      }).then((val) => {
        if (val.isConfirmed) {
          window.location.href = cartURL;
        } else {
          const cartIcon = document.querySelector(".icon-cart-empty");
          if (cartIcon == null) {
            let cartIcon = document.querySelector(".icon-cart");
            fetch("/cart.js")
              .then((response) => {
                if (!response.ok) {
                  throw new Error("Network response was not ok");
                }
                return response.json();
              })
              .then((cart) => {
                const cartCountBubble = document.querySelector(
                  '.cart-count-bubble span[aria-hidden="true"]'
                );
                const cartCountBubbleVisuallyHidden = document.querySelector(
                  ".cart-count-bubble .visually-hidden"
                );
                if (cart.item_count > 0) {
                  cartCountBubble.textContent = cart.item_count;
                  cartCountBubbleVisuallyHidden.textContent = `${cart.item_count} item${cart.item_count === 1 ? "" : "s"}`;
                } else {
                  cartCountBubble.textContent = "0";
                  cartCountBubbleVisuallyHidden.textContent = "0 items";
                }
              })
              .catch((error) => {
                console.error("Error fetching cart data:", error);
              });
          } else {
            window.location.reload();
          }
          spinner.classList.add("hidden");
          spanEle.style.visibility = "visible";
          button.classList.remove("loading");
          // window.location.reload();
        }
      });
      return final; // Return the response data
    })
    .catch((error) => {
      spinner.classList.add("hidden");
      spanEle.style.visibility = "visible";
      button.classList.remove("loading");

      console.error("Error:", error);
    });
}
